import React, { useEffect, useState } from 'react'
import { Delete, Pencil, Search } from '../../common/Icons'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { toaster } from '../../apis/commonFunctions'
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../apis/functions'
import APIS from '../../apis/routes'
import NoDataRow from '../../common/NoDataRow'
import LoadingRow from '../../common/LoadingRow'
import Button from '../../common/Button'
import Pagination from '../../common/Pagination'
import moment from 'moment/moment'
import Switch from "react-switch"

export default function Reflection() {
    const [all, setAll] = useState([]);
    const router = useNavigate();
    const [skip, setSkip] = useState(0);
    const [limit, setLimit] = useState(0);
    const [mainid, setMainId] = useState("");
    const [total, setTotal] = useState(0);
    const [params] = useSearchParams();
    const search = params.get('search') || "";
    const [loading, setLoading] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getRequest(APIS.GET_REPORTED_REFLECTIONS);
            setLoading(false);
            if (!result.data.status) {
                toaster(result.data.message, false);
            } else {
                console.log("result.data.data : ", result.data.data);
                setAll(result.data.data);
                setTotal(result.data.total_count);
            }
        } catch (err) {
            toaster(err.message, false);
            setLoading(false);
        }
    };

    function handlePageClick({ selected }) {
        setSkip(selected * limit);
    }

    useEffect(() => {
        fetchData();
    }, [search, skip]);

    const handleDelete = async () => {
        try {
            const result = await deleteRequest(`${APIS.DELETE_INTENTION}/${mainid}`);
            if (result.data.status) {
                toaster(result.data.message, true);
                fetchData();
            } else {
                toaster(result.data.message, false);
            }
        } catch (err) {
            toaster(err.message, false);
        }
    };

    return (
        <>
            <div className="top_bar row align-items-center mt-3">
                <div className="col-lg-6">
                    <div className="pagetitle">
                        Reported Reflections <br />
                    </div>
                </div>
            </div>

            <div className="row mt-5">
                <div className="table-responsive">
                    <table className="table table-lg">
                        <thead className="table-light">
                            <tr>
                                <th>S.No</th>
                                <th>Reflection Description</th>
                                <th>Report Count</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading && all.length <= 0 && <NoDataRow />}
                            {loading && <LoadingRow />}
                            {all && all.length > 0 &&
                                all.map((element, index) => (
                                    <tr key={element._id}>
                                        <td>{index + 1}</td>
                                        <td style={{ textTransform: "inherit" }}>{element.description}</td>
                                        <td style={{ textTransform: "inherit" }}>{element.reportCount}</td>
                                        <td>
                                            <div className="actions">
                                                <button
                                                    className="delete"
                                                    onClick={() => setMainId(element._id)}
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#deleteReflectionModal"
                                                >
                                                    <Delete />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                            {total > limit && (
                                <tr className="text-center">
                                    <td colSpan={20}>
                                        <Pagination handlePageClick={handlePageClick} totalCount={total} limit={limit} />
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* ------------------ Delete Reflection Modal ------------------ */}
            <div
                className="modal fade"
                id="deleteReflectionModal"
                tabIndex="-1"
                aria-labelledby="deleteReflectionModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteReflectionModalLabel">Confirm Deletion</h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete this item?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger"
                                data-bs-dismiss="modal"
                                onClick={handleDelete}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* ------------------ End Delete Reflection Modal ------------------ */}
        </>
    );
}
